import { hotelData } from '../../../mocks/hotelData';

export default function HotelInfo() {
  return (
    <div className="mb-8">
      <h2 className="text-2xl font-bold text-gray-900 mb-6">호텔 정보</h2>
      
      <div className="bg-gray-50 rounded-lg p-6 mb-6">
        <p className="text-sm text-gray-700 leading-relaxed">{hotelData.description}</p>
      </div>

      <div className="mb-6">
        <h3 className="text-lg font-bold text-gray-900 mb-4">편의시설</h3>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {hotelData.amenities.map((amenity, index) => (
            <div key={index} className="flex items-center gap-3">
              <div className="w-10 h-10 flex items-center justify-center bg-teal-50 rounded-lg text-teal-600 text-xl">
                {amenity.icon && <i className={amenity.icon}></i>}
              </div>
              <span className="text-sm text-gray-700">{amenity.name}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="mb-6">
        <h3 className="text-lg font-bold text-gray-900 mb-4">체크인/체크아웃</h3>
        <div className="grid grid-cols-2 gap-4">
          <div className="bg-gray-50 rounded-lg p-4">
            <div className="flex items-center gap-2 mb-2">
              <i className="ri-login-box-line text-teal-600 text-xl"></i>
              <span className="text-sm font-medium text-gray-700">체크인</span>
            </div>
            <p className="text-base font-bold text-gray-900">{hotelData.checkIn}부터</p>
          </div>
          <div className="bg-gray-50 rounded-lg p-4">
            <div className="flex items-center gap-2 mb-2">
              <i className="ri-logout-box-line text-teal-600 text-xl"></i>
              <span className="text-sm font-medium text-gray-700">체크아웃</span>
            </div>
            <p className="text-base font-bold text-gray-900">{hotelData.checkOut}까지</p>
          </div>
        </div>
      </div>

      <div>
        <h3 className="text-lg font-bold text-gray-900 mb-4">호텔 정책</h3>
        <ul className="space-y-2">
          {hotelData.policies.map((policy, index) => (
            <li key={index} className="flex items-start gap-2 text-sm text-gray-700">
              <i className="ri-checkbox-circle-line text-teal-600 mt-0.5"></i>
              <span>{policy}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}